import createActionTypes from '../../constants/utils';

export const GET_SHARDS = createActionTypes('COMPONENTS:SHARDS:GET_SHARDS');
export const SET_SHARD_NAME = createActionTypes('COMPONENTS:SHARDS:SET_SHARD_NAME');
export const OPEN_SHARD_NAME_EDITOR = 'COMPONENTS:SHARDS:OPEN_SHARD_NAME_EDITOR';
export const CLOSE_SHARD_NAME_EDITOR = 'COMPONENTS:SHARDS:CLOSE_SHARD_NAME_EDITOR';
